module.exports = __webpack_public_path__ + "static/media/object-group.132c42b8.svg";